module.exports = __webpack_public_path__ + "img/icon_success.2ec3939a.png";